<template>
    <div>
        <top_box :return_="true" :user_data="user_data"></top_box>
        <div class="main">
            <div class="box">
				<!-- 返回首页 -->
                <div class="return_box pointer" @click="return_">
                    <img src="../../static/return_icon.png" alt="">
                    <span>{{$t('m.PlaceOrder_01')}}</span>
                </div>
				
                <div class="address" :style="address_id == 0?'':'justify-content: space-between;'">
					<!-- 无地址 -->
                    <template v-if="address_id == 0">
                        <div class="address_left">
                            <span class="text1">{{$t('m.PlaceOrder_11')}}</span>
                            <span class="text2 pointer" @click="address_">{{$t('m.PlaceOrder_12')}}</span>
                        </div>
                        <div class="address_right">
                            <img class="pointer" src="../../static/youjiantou.png" @click="address_" alt="">
                        </div>
                    </template>
					<!-- 有地址 -->
                    <template v-else>
						<div class="addr_msg flex f-ct" @click="address_">
							<p>{{$t('m.PlaceOrder_06')}}：{{ address.name }}</p>
							<p>{{$t('m.home_13')}}：{{ address.mobile}}</p>
							<p>{{$t('m.home_12')}}：{{ address.address }}</p>
						</div>
						<div class="qx" @click="del_sle" style="color: #005efc;font-size: 14px;margin-left: 20px;cursor: pointer;">取消地址选择</div>
                    </template>
                </div>
				<!-- 订单详情 -->
                <div class="title">{{$t('m.PlaceOrder_02')}}</div>
				<!-- PC版本 -->
                <div class="tableDatabox" v-for="(item, index) in tableData" :key="index">
                    <div class="tablemain">
                        <el-table :data="[item]" border style="width: 100%">
							<template slot="empty">
								<el-empty :image-size="100" :description="$t('m.new_txt3')"></el-empty>
							</template>
                            <el-table-column :label="$t('m.MallCenter_08')" prop="chart">
                                <template slot-scope="scope">
                                    <el-image class="pointer" style="width: 60px; height: 56px" :src="scope.row.thumb"
                                        :preview-src-list="[scope.row.thumb]">
                                    </el-image>
                                </template>
                            </el-table-column>
                            <el-table-column :label="$t('m.MallCenter_09')" prop="name"></el-table-column>
                            <el-table-column :label="$t('m.MallCenter_10')" prop="cat.name"></el-table-column>
                            <el-table-column :label="$t('m.MallCenter_12')" prop="model"></el-table-column>
                            <el-table-column :label="$t('m.PlaceOrder_09')" prop="price_amount.amount_rmb"></el-table-column>
                            <el-table-column :label="$t('m.PlaceOrder_10')" prop="price_amount.amount_dollar"></el-table-column>
                        </el-table>
                    </div>
                    <div class="table_info">
                        <el-table 
						:data="[item][0].spec_list" 
						border 
						style="width: 100%"
                        :header-cell-style="{ background: '#fbfcfe', color: '#2e3341', fontWeight: '400' }">
                            <el-table-column></el-table-column>
                            <el-table-column></el-table-column>
                            <el-table-column :label="$t('m.PlaceOrder_07')" prop="spec_key_name"></el-table-column>
                            <el-table-column :label="$t('m.PlaceOrder_08')" prop="goods_num"></el-table-column>
                            <el-table-column :label="$t('m.PlaceOrder_099')" prop="price_rmb"></el-table-column>
                            <el-table-column :label="$t('m.PlaceOrder_100')" prop="price_dollar"></el-table-column>
                        </el-table>
                    </div>
                </div>
				<!-- h5的表 -->
				<div class="tableDatabox_h5">
					<!-- 其他信息 -->
					<div class="other_box" v-if="tableData" v-for="(item,index) in tableData" :key="index">
						<p class="tit"></p>
						<div class="item_o">
							<div class="status flex f-ct f-bt">
								<p>-{{$t('m.shoping_txt1')}}</p>
							</div>
							<div class="goods flex">
								<div class="l">
									<img :src="item.thumb" alt="">
								</div>
								<div class="r">
									<div class="tbox1 flex f-ct f-bt">
										<p class="line2">{{item.name}}</p>
									</div>
									<div class="tbox2 flex f-ct f-bt">
										<p>{{$t('m.MallCenter_10')}}：{{item.cat.name}}</p>
										<p style="opacity: 0;">x1</p>
									</div>
								</div>
							</div>
						</div>
						

						<div class="item flex f-ct f-bt">
							<p>{{$t('m.MallCenter_12')}}</p>
							<p>{{item.model}}</p>
						</div>
						<div class="item flex f-ct f-bt">
							<p>{{$t('m.MallCenter_09')}}</p>
							<p>￥{{item.price_amount.amount_rmb}}</p>
						</div>
						<div class="item flex f-ct f-bt">
							<p>{{$t('m.MallCenter_10')}}</p>
							<p>${{item.price_amount.amount_dollar}}</p>
						</div>
						
						
						<!-- 规格部分 -->
						<div class="ggbox">
							<!-- <div class="tit2 flex f-ct f-bt">
								<p>-{{item.goods_spec_name}}</p>
							</div> -->
							<div class="gg_box" v-for="(gg_item,gg_index) in item.spec_list" :key="gg_index">
								<div class="item_gg1 flex f-ct" @click="changradio(item,gg_index)">
									<p>{{gg_item.spec_key_name}}</p>
								</div>
								<div class="item_gg2 flex f-ct f-bt">
									<p>{{$t('m.PlaceOrder_08')}}</p>
									<p>{{$t('m.PlaceOrder_099')}}</p>
									<p>{{$t('m.PlaceOrder_100')}}</p>
								</div>
								<div class="item_gg2 flex f-ct f-bt">
									<div>
										<div style="opacity: 0;" class="pointer btnbox flex f-ct f-btc">
											<span>－</span>
										</div>
										<div class="inpunumber">
										    <el-input v-model="gg_item.goods_num" ></el-input>
										</div>
										<div style="opacity: 0;" class="pointer btnbox flex f-ct f-btc">
											<span>＋</span>
										</div>
									</div>
									<p>￥{{gg_item.price_rmb}}</p>
									<p>${{gg_item.price_dollar}}</p>
								</div>
							</div>
						</div>
					</div>	
				</div>
				<!-- 填备注 -->
                <div class="remarks">
                    <div class="remarks_title">{{$t('m.PlaceOrder_03')}}：</div>
                    <div class="inpu_box">
                        <el-input v-model="remarks" :placeholder="$t('m.PlaceOrder_04')"></el-input>
                    </div>
                </div>
                <div class="Price">
                    <div class="Price_left">
                        <p>{{$t('m.PlaceOrder_05')}}：<span class="rmb">￥{{ order_amount.rmb }}&nbsp; |</span><span>&nbsp;${{ order_amount.dollar }}</span></p>
                    </div>
                    <div class="Price_right">
                        <el-button type="danger" @click="Submit">{{$t('m.MallCenter_18')}}</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import top_box from '../../components/header_top'
import encryption from '@/utils/encryption.js'
export default {
    components: {
        top_box,
    },
    data() {
        return {
            goods_arr: [],
            srcList: ['https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg'],
            user_data: {},
            order_amount: {},
            remarks: '',     //订单备注
            address_id: 0,   //地址id
            address: {},     //默认地址
            tableData:[]
        }
    },
    mounted() {
        let user_data = JSON.parse(localStorage.getItem('user_data'))
        let address = JSON.parse(localStorage.getItem('address'))
        if (address) {
			this.address = address
			this.address_id = address.id
			localStorage.removeItem('address')
        }
        this.user_data = user_data
        if (this.$route.query.goods_arr) {
            this.goods_arr = JSON.parse(this.$route.query.goods_arr)
            this.getData()
        }
    },
    methods: {
		// 取消地址选择
		del_sle(){
			this.address_id = 0   //地址id
			this.address = {}     //默认地址
		},
		// 获取order_check 信息
        getData() {
            let param = {
                user_id: JSON.parse(localStorage.getItem('user_data')).id || '',
                goods_arr: JSON.stringify(this.goods_arr)
            }
            let sing = encryption.getSing(param)
            this.$api.order_check(param, sing).then((res) => {
                if (res.data.code == 1) {
                    this.tableData = res.data.data.goods_list || []
                    this.order_amount = res.data.data.order_amount
                }
            })
        },
        changradio(item, index) {
            console.log(item, index)
            let list = this.tableData.filter(item1 => {
                return item1.id == item.id
            })

            list[0].info.forEach(element => {
                element.Selected = false
            });

            list[0].info[index].Selected = true
        },
        address_() {
            console.log(111)
            this.$router.push({
                path: '/user/address?pageType=' + 'modify'
            })
        },
        return_() {
            this.$router.go(-1)
        },
        //下单
        Submit() {
            let param = {
                user_id: JSON.parse(localStorage.getItem('user_data')).id || '',
                address_id: this.address_id,
                goods_arr: JSON.stringify(this.goods_arr),
                msg: this.remarks
            }
            let sing = encryption.getSing(param)
            this.$api.order_do(param, sing).then((res) => {
                if (res.data.code == 1) {
                    let order_id = res.data.data
                    this.$router.push('/Submit?order_id='+order_id)
                   
                }
            })
        }
    }

}
</script>
<style lang="scss" scoped>
// .box{
//     min-width: 800px;
// }
.Price {
    padding: 40px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .Price_left {
        padding-left: 20px;
        font-size: 14px;
        font-weight: bold;
        p {
            span {
                font-size: 18px;
                font-weight: bold;

            }

            .rmb {
                color: #ef5843;
            }

        }
    }

    ::v-deep .el-button {
        background-color: #ef5843;
        width: 185px;
        height: 60px;
        font-weight: bold;
        font-size: 15px;

    }
}

.remarks {
    width: 100%;
    background-color: #fbfcfe;
    height: 50px;
    margin-top: 20px;
    border: 1px solid #eff1f6;
    display: flex;
    align-items: center;

    .remarks_title {
        width: 150px;
        height: 50px;
        line-height: 50px;
        padding-left: 20px;
        font-size: 14px;
        font-weight: bold;
    }

    .inpu_box {
        flex: 1;

        ::v-deep .el-input__inner {
            border: 0 !important;
            background-color: #fbfcfe !important;
        }
    }
}

.main {
    background-color: #fff;
    width: 100%;
    margin-top: 13px;
    padding: 20px 0;

    .box {
        width: 62%;


        margin: 0 auto;

        .return_box {
            display: flex;
            align-items: center;


            span {
                margin-left: 10px;
                font-size: 14px;
            }
        }

        .address {
            width: 100%;
            background-color: #f6f7fa;
            height: 60px;
            margin-top: 20px;
            border: 1px solid #eff1f6;
            display: flex;
            align-items: center;
            padding: 0 30px;

            justify-content: space-between;

            .address_left {
                display: flex;
                align-items: center;

                font-size: 14px;

                .text2 {
                    color: #005efc;
                    font-size: 14px;
                    margin-left: 20px;
                }
            }
        }
    }
}

.title {
    font-weight: bold;
    margin-top: 20px;
    font-size: 17px;
}

.tableDatabox {
    margin-top: 20px;
    width: 100%;

    ::v-deep .table_info {
        .el-table tr {
            background-color: #fbfcfe !important;
        }
    }
}




.el-form--inline .el-form-item {
    width: 100%;

}

::v-deep .el-form--inline .el-form-item__content {
    width: 100% !important;
}

.commodity_info {
    width: 100%;
    display: flex;
    align-items: center;

    .Selected_style {
        background-color: #ef5843 !important;
    }

    .ridio {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        margin-right: 10px;
        margin-left: 300px;

        text-align: center;
        line-height: 20px;

        img {
            width: 12px;
            height: 9px;
        }
    }


}






.user_box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-left: 5px solid #ef5843;
    height: 26px;
    padding-right: 30px;

    .user_box_left {
        padding-left: 25px;
    }

}

.search {
    margin-top: 30px;
    width: 100%;
    padding: 0 30px;
}

.classification {
    margin-top: 20px;
    display: flex;
    align-items: center;
    padding: 0 30px;

    .item {
        margin-left: 30px;
    }
}



.pagingbox {
    padding: 0 30px;
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

::v-deep.el-table th.el-table__cell {
    background-color: #e9ecf2;
    color: #000000;
}

.el-table ::v-deep.el-table__cell {
    text-align: center;
}

::v-deep .el-table--border .el-table__cell,
.el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed {
    border-right: 0 !important;
}

::v-deep .el-image {

    border-radius: 5px;
}

::v-deep .el-table--border {
    border-top: none;
}
.addr_msg{
	width: 85%;
	p{
		margin-right: 20px;
	}
}


.tableDatabox_h5{
	display: none;
}
// 宽度小于1200px
@media screen and (max-width: 1200px){
	.main{
		padding: 0;
		.box{
			width: 100%;
			padding: 1rem 0.8rem;
			.return_box{
				display: none;
			}
			.address{
				height: auto;
				margin-top: 0;
				padding: 0.3rem 0.8rem;
				min-height: 3.5rem;
				position: relative;
				.addr_msg{
					display: block;
					p{
						font-size: 0.85rem;
						margin: 0.4rem 0;
					}
				}
				.qx{
					margin-left: 0!important;
					padding: 0.5rem 0;
					font-size: 0.65rem!important;
					position: absolute;
					top: 0.1rem;
					right: 0.5rem;
				}
			}
			.title{
				padding-left: 0.8rem;
			}
			.tableDatabox{
				display: none;
			}
			.tableDatabox_h5{
				display: block;
				.other_box{
					background: #fff;
					margin: auto;
					margin-top: 0.875rem;
					padding-top: 0;
					.tit{
						font-size: 0.9rem;
						font-weight: 600;
						// padding: 0.6rem 0rem;
						border-bottom: 0.025rem solid #dddddd;
					} 
					.status{
						margin-top: 0.5rem;
						p{
							font-size: 0.55rem;
							font-weight: 600;
							color: #ef5843;
						}
					}
					.item_o{
						border-radius: 0.2rem;
						min-height: 5.825rem;
						background: #fff;
						margin: auto;
						padding-top: 0.075rem;
						padding-bottom: 1rem;
						.tips{
							padding-top: 0.9rem;
							padding-bottom: 0.2rem;
							font-size: 0.3rem;
							font-weight: 600;
							&:last-child{
								padding-top: 0.2rem;
							}
							input{
								width: 85%;
								text-align: right;
								font-size: 0.6rem;
								&::placeholder{
									color: #b9babb;
								}
							}
						}
						.goods{
							margin-top: 0.5rem;
							.l{
								width: 4.175rem;
								height: 3.95rem;
								margin-right: 0.6rem;
								img{
									width: 4.175rem;
									height: 3.95rem;
									border-radius: 0.2rem;
								}
							}
							.r{
								width: calc(100% - 3.775rem);
								.tbox1{
									p{
										font-size: 0.70rem;
										font-weight: 600;
									}
								}
								.tbox2{
									margin-top: 0.4rem;
									p{
										font-size: 0.6rem;
										color: #7d7d89;
									}
								}
							}
						}
					}
					.item{
						margin-bottom: 0.275rem;
						p{
							font-size: 0.6rem;
							&:first-child{
								width: 35%;
								font-size: 0.6rem;
								font-weight: 600;
							}
							&:last-child{
								width: 65%;
								text-align: right;
							}
						}
					}
					.ggbox{
						background: rgba(233, 236, 242, 0.4);
						padding:  0.3rem 0.5rem;
						margin-top: 1rem;
						border-radius: 0.2rem;
						.tit2{
							font-size: 0.9rem;
							font-weight: 600;
							padding: 0.6rem 0rem;
						} 
						.gg_box{
							padding: 0.2rem 0;
							.item_gg1{
								padding: 0.2rem 0;
								font-size: 0.6rem;
								text-align: center;
								margin-bottom: 0.1rem;
								div{
									display: flex;
									align-items: center;
									justify-content: center;
									border-radius: 50%;
									width: 1rem;
									height: 1rem;
									background: #ecedf0;
									margin-right: 1rem;
									img{
										width: 0.5rem;
										height: 0.5rem;
									}
								}
								.active{
									background: #ef5843;
								}
							}
							.item_gg2{
								padding: 0.2rem 0;
								div{
									display: flex;
									align-items: center;
									justify-content: center;
									width: 25%;
									.btnbox {
									    border-radius: 3px;
									    border: 2px solid #e5e5e5;
									    width: 40px;
									    height: 24px;
									    line-height: 24px;
									    font-weight: bold;
									}
									.inpunumber {
									    ::v-deep .el-input__inner {
									        border: 0 !important;
									        padding: 0 !important;
									        width: 30px;
									        text-align: center;
											background: none;
									    }
									}
								}
								p{
									font-size: 0.6rem;
									text-align: center;
									width: calc(75%/2);
									&:first-child{
										width: 25%;
									}
								}
							}
						}
					}
				}
			}
			.Price{
				display: block;
				.Price_right{
					margin-top: 0.8rem;
					::v-deep .el-button{
						margin: auto;
						display: block;
					}
				}
			}
		}
	}
}
</style>